/**
 * Target frame (enemy side of the top `FrameCluster`, #421). Shows hostile
 * target hp bar or "no target" empty state.
 *
 * Layout (#421): no longer self-positions (`position: absolute` + a
 * hardcoded `left: %`) — renders as an ordinary flex child of
 * `FrameCluster`'s enemy (right) group, extending the same
 * friendly-left/enemy-right convention `UnitFrameStack` (#138) already used
 * for the bottom roster.
 *
 * Champion resolution (#420 fix): the resource bar + cast-bar spell name now
 * resolve against the TARGET'S OWN `championId` (`WireEntity.championId`,
 * #420) instead of the hardcoded `DEFAULT_HUD_CHAMPION_ID` placeholder —
 * same bug class as #275's own-frame regression. Any target now shows its
 * real ability name/icon/resource labels, not the local warrior's.
 *
 * WP8 e2e assertions:
 *   • data-testid="target-frame"
 *   • data-hp — integer hp value
 *   • data-max-hp — integer max hp
 *   • data-empty — "true" when no target
 */

import type { ReactElement } from "react";
import { useStore } from "../store/context.js";
import { targetEntity } from "./hud-util.js";
import { UnitFrame } from "./UnitFrame.js";

export function TargetFrame(): ReactElement {
  const { state } = useStore();
  const target = targetEntity(state.hudSnapshot, state.ownSeat);

  return (
    <UnitFrame
      entity={target}
      testId="target-frame"
      align="right"
      championId={target?.championId}
      emptyText="no target"
      dimWhenEmpty={true}
      tick={state.hudSnapshot?.tick ?? 0}
      header={(ent) =>
        ent !== null ? (
          <div style={{ fontSize: 12, marginBottom: 4 }}>
            target · seat {String(ent.seat)}
          </div>
        ) : null
      }
    />
  );
}
